module.exports = __webpack_public_path__ + "img/only-devices.e1f19878.svg";